//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../Features/Features.StructureDesign.ContextAttributeBuilder.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../Features/Features.StructureDesign.FeatureSpreadsheetBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/Features.js";
let d=[[[0,"AnchorPoint",1,0],[1,"Attachment",0,"ScCollector",0],[1,"ContextAttribute",0,"Features.StructureDesign.ContextAttributeBuilder",0],[0,"GrabTabName",1,0],[0,"OrientVector",1,"Direction",0],[0,"PlaceDirection",1,0],[1,"Reference1",0,"SelectNXObject",0],[1,"Reference1Offset",0,"Expression",0],[0,"Reference1ReverseFlange",1,0],[1,"Reference2",0,"SelectNXObject",0],[1,"Reference2Offset",0,"Expression",0],[0,"Reference2ReverseFlange",1,0],[1,"RotateAngle",0,"Expression",0],[1,"StockData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0]],[],[]];
SPLM.Features.StructureDesign.GrabTabBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.GrabTabBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.GrabTabBuilder.PlaceDirections = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical"});

SPLM.Features.StructureDesign.GrabTabBuilder.AnchorPoints = Object.freeze({
    "Left" : "Left", "Center" : "Center", "Right" : "Right"});

export default SPLM;